export function sanitizeName(input: string): string {
  const sanitized = input
    .replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ\s'.-]/g, "")
    .replace(/[-'.]{2,}/g, " ")
    .replace("-", "")
    .trim();

  return sanitized.replace(/\s+/g, " ");
}
